export default __webpack_public_path__ + "static/10-c4f33814271bdec9a6215ab8b49c15a8.jpg";